module.exports = require("string-template-parser");


//////////////////
// WEBPACK FOOTER
// external "string-template-parser"
// module id = 2
// module chunks = 0